export default "__VITE_ASSET__Bw$w9yVm__"